module.exports = __webpack_public_path__ + "static/img/c4.44df466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cloud/c4.png
// module id = SHpJ
// module chunks = 0